export const masterFirebaseConfig = {
  apiKey: "AIzaSyAWYtTs0Xd2ZWkI1bi5kjN5X6lbzN095lo",
  authDomain: "putman-portfolio.firebaseapp.com",
  databaseURL: "https://putman-portfolio.firebaseio.com",
  projectId: "putman-portfolio",
  storageBucket: "",
  messagingSenderId: "905313451216"
  };



// WEBPACK FOOTER //
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/api-keys.ts